import { h } from "omi";

export function BackgroundLines() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 700 434"
      className="w-full h-full"
      preserveAspectRatio="xMidYMid slice"
    >
      <path
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="8.69356"
        d="M474.758 428.736c72.859-95.742 118.919-144.233 215.879-215.879C593.842 139.367 546.86 90.9632 472.662-5.11719"
      />
      <path
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="8.69356"
        d="M592.131 437.119C664.99 341.377 711.05 292.885 808.01 221.24 711.215 147.75 664.233 99.346 590.035 3.26562"
      />
      <path
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="8.69356"
        d="M709.5 445.502c72.859-95.742 118.919-144.234 215.879-215.879-96.794-73.49-143.777-121.894-217.975-217.9746M227.742-2.47832C154.883 93.2634 108.823 141.755 11.8633 213.4 108.658 286.89 155.64 335.295 229.838 431.375"
      />
      <path
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="8.69356"
        d="M110.371-10.865C37.512 84.8767-8.54838 133.369-105.508 205.014c96.79456 73.49 143.7772 121.894 217.975 217.974"
      />
      <path
        stroke="#212121"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="8.69356"
        d="M-7.00022-19.2478C-79.8591 76.4939-125.919 124.986-222.879 196.631c96.794 73.49 143.7771 121.894 217.9747 217.974"
      />
    </svg>
  );
}
